module.exports = __webpack_public_path__ + "fonts/AdelleSansSAGE-Bold.ff3cfcce.ttf";